import { IProcessEquipmentData } from 'shared/api/api';
import { CheckIfSectionUsesPens, FindHiddenPenOnSection } from 'shared/helpers/location-helper';
import { IsElistarOrEsf } from 'shared/helpers/work-list-helpers/esf-list-helpers/generel-esf-list-helper';

export const getSectionSelectionUpdate = (
	selectedSectionId: string,
	processEquipmentData: IProcessEquipmentData[],
	currentPenId?: string,
) => {
	const sectionHasStation = processEquipmentData.some(
		peq =>
			selectedSectionId &&
			IsElistarOrEsf(peq.equipmentType) &&
			peq.sectionId === selectedSectionId &&
			peq.unitCodes &&
			peq.unitCodes.length > 0,
	);

	let nextPenId = '';

	if (CheckIfSectionUsesPens(selectedSectionId)) {
		nextPenId = '';
	} else {
		const hiddenPenId = FindHiddenPenOnSection(selectedSectionId, currentPenId);

		if (hiddenPenId) {
			nextPenId = hiddenPenId;
		} else {
			nextPenId = currentPenId ?? '';
		}
	}

	return {
		penId: nextPenId,
		sectionId: selectedSectionId,
		sectionHasStation,
	};
};
